import React from "react";
import { useInView } from "../hooks/useInView";
import LazyImage from "./LazyImage";

const ChooseUs = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section
      id="choose-us"
      className="section-padding bg-secondary-900 text-white border-b-[1px] border-[#9FA1A7]"
    >
      <div className="container-custom">
        <div
          ref={ref}
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center"
        >
          {/* Image */}
          <div
            className={`transition-all duration-700 delay-300 h-full ${
              inView ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"
            }`}
          >
            <div className="relative h-full">
              <LazyImage
                src="/pictures/dlaczego_my_lumat.png"
                alt="Dlaczego my? Lumat - automatyka przemysłowa"
                className="w-full h-full object-cover rounded shadow-md"
              />
            </div>
          </div>

          {/* Text Content */}
          <div
            className={`transition-all duration-700 ${
              inView ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
            }`}
          >
            <h2 className="text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-medium font-heading">
              Dlaczego my?
            </h2>

            <div className="space-y-4 text-secondary-600 leading-relaxed mt-8 font-light text-white opacity-95">
              <ul className="list-disc list-inside">
                <li className="text-lg md:text-xl lg:text-xl">
                  Ponad 15 lat doświadczenia w branży
                </li>
                <li className="text-lg md:text-xl lg:text-xl">
                  Elastyczne podejście do potrzeb klienta
                </li>
                <li className="text-lg md:text-xl lg:text-xl">
                  Wsparcie w nietypowych przypadkach
                </li>
                <li className="text-lg md:text-xl lg:text-xl">
                  Pomoc w wyszukiwaniu części wycofanych z produkcji
                </li>
                <li className="text-lg md:text-xl lg:text-xl">
                  Szybka realizacja i profesjonalne doradztwo
                </li>
                <li className="text-lg md:text-xl lg:text-xl">
                  Współpraca z wiodącymi producentami
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChooseUs;
